module.exports = __webpack_public_path__ + "img/mgh-gotanda@2x.a7fe1d32.jpg";